import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_SERVICE_TYPES = "fetchServiceTypes";
export const FETCH_SERVICE_TYPE = "fetchServiceType";
export const SAVE_SERVICE_TYPE = "saveServiceType";
export const UPDATE_SERVICE_TYPE = "updateServiceType";
export const DELETE_SERVICE_TYPE = "deleteServiceType";
export const FETCH_SERVICE_PERIOD_TYPES = "fetchServicePeriodTypes";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingServiceType";

const state = {
  errors: [],
  isLoadingServiceType: false
};

const getters = {
  isLoadingServiceType() {
    return state.isLoadingServiceType;
  }
};

const actions = {
  [FETCH_SERVICE_TYPES](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-types" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SERVICE_TYPE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-types", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_SERVICE_TYPE](context, payload) {
    context.commit(SET_LOADING, true);
    let form = JSON.parse(JSON.stringify(payload));

    form.staffId = form.staffId < 0 ? null : form.staffId;

    return new Promise((resolve, reject) => {
      ApiService.post("service-types", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_SERVICE_TYPE](context, params) {
    context.commit(SET_LOADING, true);

    let form = JSON.parse(JSON.stringify(params.payload));
    const id = params.id;

    form.staffId = form.staffId < 0 ? null : form.staffId;

    return new Promise((resolve, reject) => {
      ApiService.update("service-types", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_SERVICE_TYPE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("service-types", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SERVICE_PERIOD_TYPES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("service-period-types/options")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingServiceType = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingServiceType = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
